import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-826a4e2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom" }
const _hoisted_2 = { class: "custom_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom_title_icon" }, null, -1))

import { defineAsyncComponent, ref, shallowRef } from 'vue';
import emitter from '@/utils/mitt';

export default /*#__PURE__*/_defineComponent({
  __name: 'Custom',
  setup(__props) {

const Manage = defineAsyncComponent(() => import('./components/Manage.vue'));
const TopBar = defineAsyncComponent(() => import('./components/TopBar_setup.vue'));
const RotationChart = defineAsyncComponent(() => import('./components/RotationChart_setup.vue'));
const MyLive = defineAsyncComponent(() => import('./components/MyLive_setup.vue'));
const CubeNav = defineAsyncComponent(() => import('./components/cubeNav_setup.vue'));
const MyArticle = defineAsyncComponent(() => import('./components/MyArticle_setup.vue'));
const Living = defineAsyncComponent(() => import('./components/Living_setup.vue'));
const MyImages = defineAsyncComponent(() => import('./components/MyImages_setup.vue'));
const Horizontal = defineAsyncComponent(() => import('./components/Horizontal_setup.vue'));
const Fold = defineAsyncComponent(() => import('./components/Fold_setup.vue'));

const componentList = shallowRef([
  {
    showId: -2,
    component: Manage,
  },
  {
    showId: -1,
    component: TopBar,
  },
  {
    showId: 0,
    component: RotationChart,
  },
  {
    showId: 1,
    component: CubeNav,
  },
  {
    showId: 2,
    component: Living,
  },

  {
    showId: 3,
    component: MyArticle,
  },
  {
    showId: 4,
    component: MyImages,
  },
  {
    showId: 5,
    component: MyLive,
  },
  {
    showId: 6,
    component: Horizontal,
  },
  {
    showId: 7,
    component: Fold,
  },
]);

const component: any = shallowRef(TopBar);

const title = ref('顶部栏装修');
const showId = ref(-1);
const custom = ref();
const labelId = ref(0);
const time = ref(new Date());
// 基础组件
emitter.on('custom', (e: any) => {
  showId.value = e.type;
  custom.value = {};
  if (e.item) {
    title.value = e.item.name;
    labelId.value = e.index;
    custom.value = e.item;
  } else {
    labelId.value = 0;
    title.value = e.name;
    custom.value = e;
  }
  component.value = componentList.value.filter((res) => {
    return res.showId == showId.value;
  })[0].component;
  time.value = new Date();
});

const display = ref(true);
emitter.on('display', (e: any) => {
  display.value = e;
});
emitter.on('storehouse', (e: any) => {
  custom.value = e;
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "custom_content",
      style: _normalizeStyle({ display: display.value ? 'block' : 'none' })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(title.value), 1)
      ]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
        key: time.value,
        custom: custom.value,
        labelId: labelId.value
      }, null, 8, ["custom", "labelId"]))
    ], 4),
    _createElementVNode("div", {
      class: "custom_close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (display.value = !display.value))
    }, [
      _createVNode(_component_svg_icon, {
        style: _normalizeStyle({ transform: display.value ? '' : 'rotate(180deg)' }),
        "icon-class": "close"
      }, null, 8, ["style"])
    ])
  ]))
}
}

})